import styled from 'styled-components';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  backdrop-filter: blur(4px);
`;

export const DocumentContainer = styled.div`
  width: 95vw;
  max-width: 1400px;
  height: 90vh;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 32px;
  border-bottom: 1px solid #e5e5e5;
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
  color: white;
  position: relative;
  overflow: hidden;
`;

export const ModalTitle = styled.h2`
  margin: 0;
  color: white;
  font-size: 26px;
  font-weight: 700;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  letter-spacing: 0.5px;
`;

export const CloseButton = styled.button`
  background: rgba(255, 255, 255, 0.2);
  border: 2px solid rgba(255, 255, 255, 0.3);
  font-size: 28px;
  cursor: pointer;
  color: white;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  position: relative;
  z-index: 1;
  &:hover {
    background: rgba(255, 255, 255, 0.3);
    border-color: rgba(255, 255, 255, 0.5);
    transform: rotate(90deg) scale(1.1);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
    color: #333;
  }
  &:active {
    transform: rotate(90deg) scale(0.95);
  }
`;

export const ScrollableContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 32px;
  background: linear-gradient(180deg, #ffffff 0%, #f8f9fa 100%);
  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: linear-gradient(45deg, #007bff, #0056b3);
    border-radius: 4px;
    transition: background 0.3s ease;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: linear-gradient(45deg, #0056b3, #003d82);
  }
`;

export const SectionTitle = styled.h3`
  color: #2c3e50;
  font-size: 20px;
  font-weight: 700;
  margin: 0 0 20px 0;
  padding: 12px 20px;
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
  color: white;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0, 123, 255, 0.3);
  position: relative;
  overflow: hidden;
`;
export const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 20px;
  margin-bottom: 32px;
`;

export const InfoItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  transition: transform 0.2s ease;
  &:hover {
    transform: translateY(-2px);
  }
`;

export const InfoItemWithTooltip = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative;
  transition: transform 0.2s ease;
  &:hover {
    transform: translateY(-2px);
  }
`;

export const InfoValueContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const InfoLink = styled.div<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${props => props.disabled ? '#9e9e9e' : '#0090D3'};
  font-family: 'Inter', sans-serif;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  transition: color 0.2s ease-in-out;
  font-size: 14px;
  margin-top: 4px;
  user-select: none;
  &:hover {
    color: ${props => props.disabled ? '#9e9e9e' : '#007bb5'};
  }
  svg {
    transition: transform 0.2s ease;
    flex-shrink: 0;
  }
  &:hover svg {
    transform: ${props => props.disabled ? 'none' : 'scale(1.1)'};
  }
  span {
    pointer-events: ${props => props.disabled ? 'none' : 'auto'};
  }
`;

export const InfoLabel = styled.span`
  font-weight: 700;
  color: #495057;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const InfoValue = styled.span`
  color: #212529;
  font-size: 16px;
  padding: 12px 16px;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 10px;
  border: 2px solid #e9ecef;
  transition: all 0.3s ease;
  font-weight: 500;
  &:hover {
    border-color: #007bff;
    box-shadow: 0 4px 12px rgba(0, 123, 255, 0.15);
    transform: translateY(-1px);
  }
  &.extra-info-block {
    background: #f8f9fa;
    padding: 16px;
    border-radius: 8px;
    margin-bottom: 48px;
  }
  &.total-value {
    font-weight: bold;
    font-size: 18px;
    color: #007bff;
  }
`;

export const ItemCard = styled.div`
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border: 2px solid #e9ecef;
  border-radius: 16px;
  margin-bottom: 32px;
  overflow: hidden;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);
    border-color: #007bff;
  }
`;

export const ItemHeader = styled.div`
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
  color: white;
  padding: 20px 28px;
  position: relative;
  overflow: hidden;
  h4 {
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    position: relative;
    z-index: 1;
  }
`;

export const ItemContent = styled.div`
  padding: 28px;
  h5 {
    color: #495057;
    font-size: 18px;
    font-weight: 700;
    margin: 0 0 16px 0;
    padding: 8px 16px;
    background: linear-gradient(135deg, #e9ecef 0%, #f8f9fa 100%);
    border-left: 4px solid #007bff;
    border-radius: 8px;
  }
  .offered-product-title, .additional-services-title, .feedstock-title, .price-details-title {
    margin-top: 16px;
  }
`;

export const ServicesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 20px;
`;

export const ServiceItem = styled.div`
  padding: 16px 20px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 12px;
  border: 2px solid #e9ecef;
  transition: all 0.3s ease;
  &:hover {
    border-color: #007bff;
    transform: translateX(8px);
    box-shadow: 0 4px 12px rgba(0, 123, 255, 0.15);
  }
  strong {
    color: #007bff;
    font-weight: 700;
  }
`;

export const AttachmentsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 32px;
  margin-top: 16px;
`;

export const AttachmentItem = styled.div`
  padding: 16px 20px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 12px;
  border: 2px solid #e9ecef;
  color: #495057;
  transition: all 0.3s ease;
  cursor: pointer;
  &:hover {
    border-color: #28a745;
    transform: translateX(8px);
    box-shadow: 0 4px 12px rgba(40, 167, 69, 0.15);
    color: #28a745;
  }
`;

export const MessageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-size: 20px;
  color: #666;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 16px;
  padding: 40px;
  margin: 20px;
`;

export const ErrorMessage = styled.div`
  color: #dc3545;
  background: linear-gradient(135deg, #f8d7da 0%, #f5c6cb 100%);
  border: 2px solid #f5c6cb;
  border-radius: 12px;
  padding: 20px;
  margin: 20px;
  text-align: center;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(220, 53, 69, 0.15);
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 1.5rem;
`;

export const TableHeaderCell = styled.th<{ width?: string }>`
  background-color: #f8f9fa;
  padding: 0.75rem;
  text-align: left;
  font-weight: 600;
  border: 1px solid #dee2e6;
  width: ${({ width }) => width || 'auto'};
`;

export const TableCell = styled.td<{ width?: string }>`
  padding: 0.75rem;
  border: 1px solid #dee2e6;
  width: ${({ width }) => width || 'auto'};
`;

export const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: #f2f2f2;
  }
`;
